__turbopack_context__.v({
  "header": "uOIRYG_header",
  "headerLeft": "uOIRYG_headerLeft",
  "headerRight": "uOIRYG_headerRight",
  "title": "uOIRYG_title",
});
